import { IPromise, Injectable } from "angular";
import { ColDef } from "../../records/grids/columns/colDef";
import { IQuery } from "../../records/server/query";

export const vsServiceName = "processGroupConfigService";
export const vsProviderName = `${vsServiceName}`;

export interface ProcessGroupConfig {
  baseSref: string;
  processGroupName: string;
  onSelectDataObject: Injectable<(...args: any[]) => IPromise<any>>;
  getCreateProcessDto: Injectable<(...args: any[]) => any>;
  additionalGridColumns?: Injectable<(...any: any[]) => ColDef[]>;
  defaultQuery?: Injectable<(...any: any[]) => IQuery>;
  processDetailTemplate: string;
}
